/**
 * Russian locale dictionary.
 * Keys are flat strings; values are display strings (may contain {{placeholder}} for interpolation).
 */
export const ru: Record<string, string> = {
  // HUD
  "hud.mana": "СВЕТ (ЖИЗНЬ)",
  "hud.tempo": "\u0422\u0415\u041c\u041f",
  "hud.blessing": "\u0411\u041b\u0410\u0413\u041e\u0421\u041b\u041e\u0412\u0415\u041d\u0418\u0415",
  "hud.pressSpace": "\u041f\u0440\u043e\u0431\u0435\u043b \u2014 \u043d\u0430\u0447\u0430\u0442\u044c \u0432\u043e\u043b\u043d\u0443",
  "hud.chapelCost": "Часовня: {{cost}} Света",
  "hud.wallCost": "Стена: {{cost}} Света",
  "hud.amplifierCost": "Усилитель: {{cost}} Света",
  "hud.trapCost": "Ловушка: {{cost}} Света",
  "hud.modeAmp": "\u0423\u0441\u0438\u043b\u0438\u0442\u0435\u043b\u044c",
  "hud.modeTrap": "\u041b\u043e\u0432\u0443\u0448\u043a\u0430",
  "hud.relicCost": "Реликвия: {{cost}} Света",
  "hud.shrineCost": "Святилище: {{cost}} Света",
  "hud.modeShrine": "\u0421\u0432\u044f\u0442\u0438\u043b\u0438\u0449\u0435",
  "hud.modeLabel": "\u0420\u0435\u0436\u0438\u043c [W/A/T/R]:",
  "hud.modeTower": "\u0427\u0430\u0441\u043e\u0432\u043d\u044f",
  "hud.modeWall": "\u0421\u0442\u0435\u043d\u0430",
  "hud.horde": "\u041e\u0420\u0414\u0410",
  "hud.spawned": "{{spawned}}/{{total}} \u044f\u0432\u0438\u043b\u043e\u0441\u044c",
  "hud.next": "\u0414\u0430\u043b\u044c\u0448\u0435:",
  "hud.mobType.Normal": "\u0427\u0435\u0440\u0442\u0438",
  "hud.mobType.Swarm": "\u0411\u0435\u0441\u044b",
  "hud.mobType.Armored": "\u0414\u0435\u043c\u043e\u043d\u044b-\u043b\u0430\u0442\u043d\u0438\u043a\u0438",
  "hud.mobType.Giant": "\u041a\u043d\u044f\u0437\u044c\u044f \u0442\u044c\u043c\u044b",
  "hud.mobType.Runner": "\u0422\u0435\u043d\u0438",
  "hud.nextDetails": "{{count}}\u00d7 HP {{hp}}",
  "hud.hint.clickGround": "\u041f\u043e \u0437\u0435\u043c\u043b\u0435 \u2014 \u0447\u0430\u0441\u043e\u0432\u043d\u044f",
  "hud.hint.keys": "1-8 \u2014 \u0440\u0435\u043b\u0438\u043a\u0432\u0438\u044f",
  "hud.hint.clickChapel": "\u041f\u043e \u0447\u0430\u0441\u043e\u0432\u043d\u0435 \u2014 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044c",
  "hud.hint.sanctify": "U \u0443\u043b\u0443\u0447\u0448\u0438\u0442\u044c  D \u0434\u0443\u0431\u043b\u0438\u043a\u0430\u0442  C \u0441\u043b\u0438\u0442\u044c",
  "hud.hint.meltdown": "X \u0440\u0430\u0441\u043f\u043b\u0430\u0432\u0438\u0442\u044c",
  "hud.inventory": "\u0420\u0435\u043b\u0438\u043a\u0432\u0438\u0438:",
  "hud.noRelics": "\u041d\u0435\u0442 \u0440\u0435\u043b\u0438\u043a\u0432\u0438\u0439 (1-8 \u0447\u0442\u043e\u0431\u044b \u043f\u0440\u0438\u0437\u0432\u0430\u0442\u044c)",
  "hud.hint.bomb": "\u041f\u0435\u0440\u0435\u0442\u0430\u0449\u0438 \u0440\u0435\u043b\u0438\u043a\u0432\u0438\u044e \u043d\u0430 \u043f\u043e\u043b\u0435 \u2014 \u0431\u043e\u043c\u0431\u0430 AoE",
  // DOM HUD — новые ключи Phase 2
  "hud.settings": "\u041d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438",
  "battleMenu.title": "Настройки",
  "battleMenu.audioOn": "Звук: вкл",
  "battleMenu.audioOff": "Звук: выкл",
  "battleMenu.resume": "Вернуться к бою",
  "battleMenu.restart": "Перезапустить битву",
  "battleMenu.exit": "Выйти на карту",
  "hud.priest": "\u0416\u0440\u0435\u0446 \u0423\u0440. {{level}}",
  "hud.grace": "\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u044c {{grace}}",
  "buddha.hud.monk": "Монах Ур. {{level}}",
  "buddha.hud.karma": "Карма {{grace}}",
  "hud.buildings": "\u041f\u041e\u0421\u0422\u0420\u041e\u0419\u041a\u0418",
  "hud.buildingsHidden": "{{n}} \u0441\u043a\u0440\u044b\u0442\u043e",
  "hud.relics": "\u0420\u0415\u041b\u0418\u041a\u0412\u0418\u0418",
  "hud.relicsCount": "{{filled}} / {{total}}",
  "hud.actions": "\u0414\u0415\u0419\u0421\u0422\u0412\u0418\u042f",
  "hud.actionsHint": "hold [U/D/X]",
  "hud.actionCreate": "\u0421\u043e\u0437\u0434\u0430\u0442\u044c",
  "hud.actionDual": "\u0414\u0443\u0430\u043b",
  "hud.actionCombine": "\u0421\u043b\u0438\u0442\u044c",
  "hud.actionSanctify": "\u041e\u0441\u0432\u044f\u0442\u0438\u0442\u044c",
  "hud.actionBomb": "\u0411\u043e\u043c\u0431\u0430",
  "hud.actionMelt": "\u0420\u0430\u0441\u043f\u043b\u0430\u0432\u0438\u0442\u044c",
  "hud.actionRandom": "\u0421\u043b\u0443\u0447\u0430\u0439\u043d\u0430\u044f",
  "hud.speed0Title": "\u0422\u0438\u0448\u0438\u043d\u0430 (0\u00d7) \u2014 \u043f\u0430\u0443\u0437\u0430 \u043e\u0440\u0434\u044b",
  "hud.speed1Title": "\u041c\u0430\u0440\u0448 (1\u00d7)",
  "hud.speed3Title": "\u041f\u044b\u043b (3\u00d7)",
  "hud.waveCallNext": "\u0412\u043e\u043b\u043d\u0430 {{n}} \u2014 \u043f\u0440\u0438\u0437\u0432\u0430\u0442\u044c \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0433\u043e \u0441\u0435\u0439\u0447\u0430\u0441",
  "hud.waveDone": "\u0412\u043e\u043b\u043d\u0430 {{n}} \u2014 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0430",
  "hud.waveLocked": "\u0412\u043e\u043b\u043d\u0430 {{n}} \u2014 \u0435\u0449\u0451 \u043d\u0435 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0430",
  "hud.waveLabel": "\u0412\u041e\u041b\u041d\u0410",
  "hud.waveTitle": "\u0412\u041e\u041b\u041d\u0410 {{index}}",
  "hud.waveSpawned": "{{spawned}}/{{total}} \u044f\u0432\u0438\u043b\u043e\u0441\u044c",
  "hud.nextTitle": "\u0414\u0410\u041b\u0428\u0415",
  "hud.nextWaveDetails": "{{mobType}} · {{count}}\u00d7 HP {{hp}}",
  "hud.topbarWave": "\u0412{{index}} \u00b7 {{spawned}}/{{total}}",
  "hud.topbarNext": "\u0414\u0430\u043b\u044c\u0448\u0435: {{mobType}}",
  "hud.prepSpace": "\u2328 \u041f\u0440\u043e\u0431\u0435\u043b \u0438\u043b\u0438 \u00ab\u0412\u043e\u043b\u043d\u0430 1\u00bb \u2014 \u043d\u0430\u0447\u0430\u0442\u044c \u0437\u0430\u0449\u0438\u0442\u0443",
  "hud.buildChapel": "\u0427\u0430\u0441\u043e\u0432\u043d\u044f",
  "hud.buildWall": "\u0421\u0442\u0435\u043d\u0430",
  "hud.buildAmplifier": "\u0423\u0441\u0438\u043b\u0438\u0442\u0435\u043b\u044c-\u043c\u043e\u043d\u0430\u0445",
  "hud.buildTrap": "\u041b\u043e\u0432\u0443\u0448\u043a\u0430",
  "hud.buildShrine": "\u0421\u0432\u044f\u0442\u0438\u043b\u0438\u0449\u0435",
  "hud.createGemHint": "\u041d\u0430\u0436\u043c\u0438 1-8 \u0434\u043b\u044f \u0432\u044b\u0431\u043e\u0440\u0430 \u0446\u0432\u0435\u0442\u0430",

  "hud.upgradeCost": "Цена освящения: {{cost}}",
  "hud.damage": "Урон: {{min}} - {{max}}",
  "hud.range": "Радиус: {{range}}",
  "hud.fireRate": "Темп: {{rate}}/с",
  // Map / World
  "map.title": "Sanctified Lands — Святые Земли",
  "map.priestLv": "\u0416\u0440\u0435\u0446 \u0423\u0440. {{level}}",
  "map.xpProgress": "{{xp}} / {{next}} \u043e\u043f\u044b\u0442\u0430",
  "map.worldMap": "\u041d\u0430 \u043a\u0430\u0440\u0442\u0443",
  "map.launchCta": "\u041d\u0430\u0447\u0430\u0442\u044c \u0437\u0430\u0449\u0438\u0442\u0443",
  "map.startDefense": "\u041d\u0430\u0447\u0430\u0442\u044c \u0437\u0430\u0449\u0438\u0442\u0443",

  // Settings
  "settings.title": "\u0417\u0430\u0449\u0438\u0442\u0430 \u2014 {{field}}",
  "settings.hordeHp": "\u0417\u0434\u043e\u0440\u043e\u0432\u044c\u0435 \u043e\u0440\u0434\u044b",
  "settings.extraHordes": "\u0414\u043e\u043f. \u0432\u043e\u043b\u043d\u044b",
  "settings.trials": "\u0418\u0441\u043f\u044b\u0442\u0430\u043d\u0438\u044f",
  "settings.resilientHorrors": "\u0421\u0442\u043e\u0439\u043a\u0430\u044f \u043d\u0435\u0447\u0438\u0441\u0442\u044c (\u00d72.63 \u0438\u0437\u0433\u043d\u0430\u043d\u0438\u0435)",
  "settings.unholyVigor": "\u041d\u0435\u0447\u0435\u0441\u0442\u0438\u0432\u0430\u044f \u043c\u043e\u0449\u044c (+50% HP \u043f\u0440\u0438 \u0432\u043e\u0437\u0432\u0440\u0430\u0442\u0435)",
  "settings.graceMult": "\u041c\u043d\u043e\u0436\u0438\u0442\u0435\u043b\u044c \u0431\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u0438: \u00d7{{mult}}",
  "settings.begin": "\u041d\u0430\u0447\u0430\u0442\u044c \u0437\u0430\u0449\u0438\u0442\u0443",
  "settings.retreat": "\u041e\u0442\u0441\u0442\u0443\u043f\u0438\u0442\u044c [Esc]",

  // Result overlay
  "result.sanctified": "\u041e\u0421\u0412\u042f\u0429\u0415\u041d\u041e!",
  "result.fallen": "\u041f\u0410\u041b\u041e",
  "result.clickRetreat": "\u041a\u043b\u0438\u043a \u2014 \u043e\u0442\u0441\u0442\u0443\u043f\u0438\u0442\u044c",

  // Story
  "story.clickToContinue": "\u041d\u0430\u0436\u043c\u0438\u0442\u0435, \u0447\u0442\u043e\u0431\u044b \u043f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c...",
  "story.intro.panel1": "Святые Земли веками процветали под защитой Священных Реликвий. Мир и покой царили в этих краях...",
  "story.intro.panel2": "Но однажды небо раскололось. Из кроваво-красного разлома хлынули легионы Бездны.",
  "story.intro.panel3": "Вы — верховный жрец, последний оплот надежды. Используйте силу реликвий, чтобы изгнать зло!",
  "story.hollow_one.panel1": "В глубинах оскверненного леса вы нашли древний фолиант. Похоже, это вторжение было предсказано...",
  "buddha.story.intro.panel1": "Держи рубеж. Сохрани тишину храма.",

  // Battle summary overlay
  "summary.title.win": "\u041e\u0421\u0412\u042f\u0429\u0415\u041d\u041e!",
  "summary.title.lose": "\u041f\u0410\u041b\u041e",
  "summary.kills": "\u0423\u0431\u0438\u0442\u043e",
  "summary.banishes": "\u041f\u0440\u043e\u0440\u0432\u0430\u043b\u0438\u0441\u044c",
  "summary.bombs": "\u0411\u043e\u043c\u0431 \u0431\u0440\u043e\u0448\u0435\u043d\u043e",
  "summary.earlyCalls": "\u0420\u0430\u043d\u043d\u0438\u0435 \u0432\u044b\u0437\u043e\u0432\u044b \u0432\u043e\u043b\u043d\u044b",
  "summary.earlyLight": "\u0421\u0432\u0435\u0442 \u0437\u0430 \u0440\u0430\u043d\u043d\u0438\u0439 \u0441\u043f\u0430\u0432\u043d",
  "summary.duration": "\u0414\u043b\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c",
  "summary.xpEarned": "\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u044c \u0437\u0430\u0440\u0430\u0431\u043e\u0442\u0430\u043d\u0430",
  "summary.retreat": "\u041a\u043b\u0438\u043a \u2014 \u043d\u0430 \u043a\u0430\u0440\u0442\u0443",

  // Skills panel
  "skills.title": "\u0414\u0443\u0445\u043e\u0432\u043d\u044b\u0435 \u0434\u0430\u0440\u044b",
  "skills.grace": "\u0421\u0432\u043e\u0431\u043e\u0434\u043d\u043e: {{n}} / {{total}}",
  "skills.button": "\u0414\u0430\u0440\u044b [S]",
  "skills.lvMax": "\u0423\u0440. {{lv}}/{{max}}",
  "skills.val": "\u0437\u043d\u0430\u0447: {{v}}",
  "skills.needLevel": "\u043d\u0443\u0436\u0435\u043d \u0443\u0440. {{req}}",
  "skills.needPoints": "\u043d\u0443\u0436\u043d\u043e {{cost}}",
  "skills.maxed": "\u041c\u0410\u041a\u0421",
  "skills.costShort": "\u0446\u0435\u043d\u0430: {{cost}}",
  "skills.addTitle": "\u0414\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0443\u0440\u043e\u0432\u0435\u043d\u044c (Shift: \u0434\u043e\u0431\u0430\u0432\u0438\u0442\u044c \u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0432\u043e\u0437\u043c\u043e\u0436\u043d\u043e)",
  "skills.refundTitle": "\u0412\u0435\u0440\u043d\u0443\u0442\u044c \u0443\u0440\u043e\u0432\u0435\u043d\u044c (Shift: \u0432\u0435\u0440\u043d\u0443\u0442\u044c \u0432\u0441\u0451)",

  // Skill names (27 skills, index 0-26)
  "skill.0": "Больше Света в начале",
  "skill.1": "Восполнение Света",
  "skill.2": "\u0421\u0442\u043e\u0438\u043c\u043e\u0441\u0442\u044c \u0438\u0437\u0433\u043d\u0430\u043d\u0438\u044f",
  "skill.3": "\u0421\u043d\u0438\u0436\u0435\u043d\u0438\u0435 \u0441\u0442\u043e\u0438\u043c\u043e\u0441\u0442\u0438 \u0440\u0435\u043b\u0438\u043a\u0432\u0438\u0439",
  "skill.4": "\u0421\u0442\u043e\u0438\u043c\u043e\u0441\u0442\u044c \u043f\u043e\u0441\u0442\u0440\u043e\u0435\u043a",
  "skill.5": "\u0420\u0430\u0437\u0440\u0443\u0448\u0435\u043d\u0438\u0435",
  "skill.6": "Мастерство пламени",
  "skill.7": "Кровавые узы",
  "skill.8": "Взрывная ярость",
  "skill.9": "Мастерство молнии",
  "skill.10": "Мастерство цепи",
  "skill.11": "Сила усилителя",
  "skill.12": "Дешёвый резерв и разблокировка",
  "skill.13": "Двойная реликвия",
  "skill.14": "Тройная реликвия",
  "skill.15": "Мастерство замедления",
  "skill.16": "Пробитие брони",
  "skill.17": "Святилища",
  "skill.18": "Мастерство эфира",
  "skill.19": "Сбор Света",
  "skill.20": "\u041b\u043e\u0432\u0443\u0448\u043a\u0438",
  "skill.21": "\u0423\u0440\u043e\u043d",
  "skill.22": "\u0421\u043b\u0443\u0447\u0430\u0439\u043d\u0430\u044f \u0440\u0435\u043b\u0438\u043a\u0432\u0438\u044f",
  "skill.23": "\u0421\u043a\u043e\u0440\u043e\u0441\u0442\u044c \u0443\u0441\u0442\u0430\u043d\u043e\u0432\u043a\u0438",
  "skill.24": "\u0421\u043a\u043e\u0440\u043e\u0441\u0442\u0440\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c",
  "skill.25": "\u0414\u0430\u043b\u044c\u043d\u043e\u0441\u0442\u044c",
  "skill.26": "Значки в Свет",

  // Skill tooltips (panel of spiritual gifts)
  "skill.desc.0": "Больше стартового Света и больший максимум Света в начале каждого боя.",
  "skill.desc.1": "Быстрее пассивное восстановление Света и больше Света за убитых демонов.",
  "skill.desc.2": "Дешевле Свет на изгнание демона (вернуть в яму, не убивая).",
  "skill.desc.3": "Меньше Света на создание новых реликвий и на слияние реликвий в кузнице.",
  "skill.desc.4": "Дешевле Свет на часовни, стены, усилители, ловушки и святилища.",
  "skill.desc.5": "Больше возврата Света при сносе постройки (сверх базовых 50%).",
  "skill.desc.6": "Сильнее пламя (зелёный): больше урона со временем, пока пламя жжёт врага.",
  "skill.desc.7": "Сильнее ярость / кровавые узы (красный): критические залпы бьют больнее.",
  "skill.desc.8": "Больше урон от яростных взрывов при детонации реликвий и брызгах урона.",
  "skill.desc.9": "Сильнее буря (оранжевый): удары по нескольким целям и осколки по площади.",
  "skill.desc.10": "Сильнее цепь (лайм): больше прыжков или мощнее удар по следующей цели.",
  "skill.desc.11": "Усилители сильнее ускоряют стрельбу соседних часовен.",
  "skill.desc.12": "Дешевле расширять резерв Света и проще открывать высокие уровни ёмкости.",
  "skill.desc.13": "Двухцветные реликвии сильнее, комбинации двух типов выгоднее.",
  "skill.desc.14": "Выше шанс, что новая реликвия сразу получит повышенный грейд.",
  "skill.desc.15": "Замедление (фиолетовый) держится дольше или сильнее на быстрых врагах.",
  "skill.desc.16": "Пробитие брони (синий) снимает больше брони — следующие выстрелы больнее.",
  "skill.desc.17": "Святилища отдают заряд с большим уроном по демонам.",
  "skill.desc.18": "Эфир (бирюзовый): шок срабатывает чаще или длится дольше.",
  "skill.desc.19": "Сбор Света (жёлтый): больше Света с попаданий и с луча сбора.",
  "skill.desc.20": "Ловушки бьют сильнее, эффекты реликвии в зоне ловушки действуют мощнее.",
  "skill.desc.21": "Прямой бонус к урону реликвий — выигрывают все часовни.",
  "skill.desc.22": "Первая случайная стартовая реликвия на поле с большей силой.",
  "skill.desc.23": "Меньше времени на установку, перенос и замену реликвий в часовнях.",
  "skill.desc.24": "Часовни со стреляющей реликвией стреляют чаще (меньше пауза между залпами).",
  "skill.desc.25": "Больше дальность стрельбы часовен — реликвии достают демонов дальше.",
  "skill.desc.26": "Значки за прохождение полей дают дополнительный стартовый Свет в боях.",

  // Gem short names (buttons, labels)
  "gem.name.Yellow": "Свет",
  "gem.name.Orange": "Взрыв",
  "gem.name.Red": "Крит",
  "gem.name.Purple": "Замедление",
  "gem.name.Green": "Яд",
  "gem.name.Blue": "Броня",
  "gem.name.Cyan": "Шок",
  "gem.name.Lime": "Цепь",
  "gem.level": "Ур. {{lvl}}",

  // Gem Effects (full description, for tooltips)
  "gem.effect.Yellow": "Свет: +0.3×ур. маны за попадание",
  "gem.effect.Orange": "Взрыв: 14% шанс — полный урон по всем вблизи (радиус 1 кл.)",
  "gem.effect.Red": "Крит: 18% шанс — ×2 урона",
  "gem.effect.Purple": "Замедление: −30% скорость на 2 сек.",
  "gem.effect.Green": "Яд: 8×ур. ур/сек в течение 2.5 сек.",
  "gem.effect.Blue": "Броня: −0.18×ур. брони навсегда",
  "gem.effect.Cyan": "Шок: 17% шанс — оглушение на 1.5 сек.",
  "gem.effect.Lime": "Цепь: 25% шанс — удар по 2-й цели (60% урона)",

  // Stats panel
  "stats.title": "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430 \u0416\u0440\u0435\u0446\u0430",
  "stats.button": "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430 [I]",
  "stats.summaryHeader": "\u0421\u0432\u043e\u0434\u043a\u0430",
  "stats.timePlayed": "\u0412\u0440\u0435\u043c\u044f \u0432 \u0438\u0433\u0440\u0435",
  "stats.battles": "\u0411\u043e\u0451\u0432",
  "stats.wins": "\u041f\u043e\u0431\u0435\u0434\u044b",
  "stats.losses": "\u041f\u043e\u0440\u0430\u0436\u0435\u043d\u0438\u044f",
  "stats.winRate": "\u041f\u0440\u043e\u0446\u0435\u043d\u0442 \u043f\u043e\u0431\u0435\u0434",
  "stats.killsHeader": "\u0418\u0441\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043b\u044c",
  "stats.totalKills": "\u0423\u0431\u0438\u0442\u043e \u0434\u0435\u043c\u043e\u043d\u043e\u0432",
  "stats.totalBanishes": "\u0418\u0437\u0433\u043d\u0430\u043d\u043e \u0434\u0435\u043c\u043e\u043d\u043e\u0432",
  "stats.earlyHurryHeader": "\u0420\u0430\u043d\u043d\u0438\u0435 \u0432\u043e\u043b\u043d\u044b",
  "stats.manaFromEarlyWaves": "\u0421\u0432\u0435\u0442 \u0437\u0430 \u0440\u0430\u043d\u043d\u0438\u0439 \u0441\u043f\u0430\u0432\u043d (\u0432\u0441\u0435\u0433\u043e)",
  "stats.earlyWaveHurries": "\u0412\u044b\u0437\u043e\u0432\u043e\u0432 \u0440\u0430\u043d\u044c\u0448\u0435 \u0441\u0440\u043e\u043a\u0430 (\u0432\u0441\u0435\u0433\u043e)",
  "stats.fieldsHeader": "\u041b\u0443\u0447\u0448\u0438\u0435 \u043f\u043e\u043b\u044f",
  "stats.colField": "\u041f\u043e\u043b\u0435",
  "stats.colWins": "\u041f",
  "stats.colFails": "\u041d",
  "stats.colXp": "\u041b\u0443\u0447\u0448\u0438\u0439 \u043e\u043f\u044b\u0442",

  // Tutorial overlay
  "tutorial.step1": "\u041d\u0430\u0436\u043c\u0438 1\u20138 \u2014 \u043f\u0440\u0438\u0437\u0432\u0430\u0442\u044c \u0440\u0435\u043b\u0438\u043a\u0432\u0438\u044e",
  "tutorial.step2": "\u041a\u043b\u0438\u043a \u043f\u043e \u0447\u0430\u0441\u043e\u0432\u043d\u0435 \u2014 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0440\u0435\u043b\u0438\u043a\u0432\u0438\u044e",
  "tutorial.step3": "\u041f\u0440\u043e\u0431\u0435\u043b \u2014 \u043d\u0430\u0447\u0430\u0442\u044c \u0432\u043e\u043b\u043d\u0443",
  "tutorial.step4": "\u041f\u0440\u0430\u0432\u044b\u0439 \u043a\u043b\u0438\u043a \u2014 \u0441\u043d\u043e\u0441 (\u0432\u043e\u0437\u0432\u0440\u0430\u0442 50%)",
  "tutorial.next": "\u0414\u0430\u043b\u0435\u0435 \u2192",
  "tutorial.skip": "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c",
  "tutorial.firstGem": "\u0421\u043d\u0430\u0447\u0430\u043b\u0430 \u0441\u043e\u0437\u0434\u0430\u0439 \u0440\u0435\u043b\u0438\u043a\u0432\u0438\u044e \u0438 \u043f\u043e\u043c\u0435\u0441\u0442\u0438 \u0432 \u0447\u0430\u0441\u043e\u0432\u043d\u044e",

  // Achievements
  "stats.achievementsHeader": "\u0414\u043e\u0441\u0442\u0438\u0436\u0435\u043d\u0438\u044f",
  "stats.achievementsUnlocked": "{{n}} / {{total}} \u043f\u043e\u043b\u0443\u0447\u0435\u043d\u043e",
  "achievement.first_blood.name": "\u041f\u0435\u0440\u0432\u0430\u044f \u043a\u0440\u043e\u0432\u044c",
  "achievement.first_blood.desc": "\u0423\u0431\u0435\u0439 \u043f\u0435\u0440\u0432\u043e\u0433\u043e \u0434\u0435\u043c\u043e\u043d\u0430",
  "achievement.first_victory.name": "\u041f\u0435\u0440\u0432\u0430\u044f \u043f\u043e\u0431\u0435\u0434\u0430",
  "achievement.first_victory.desc": "\u0412\u044b\u0438\u0433\u0440\u0430\u0439 \u043f\u0435\u0440\u0432\u044b\u0439 \u0431\u043e\u0439",
  "achievement.slayer_100.name": "\u0418\u0441\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043b\u044c I",
  "achievement.slayer_100.desc": "\u0423\u0431\u0435\u0439 100 \u0434\u0435\u043c\u043e\u043d\u043e\u0432",
  "achievement.slayer_1000.name": "\u0418\u0441\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043b\u044c II",
  "achievement.slayer_1000.desc": "\u0423\u0431\u0435\u0439 1000 \u0434\u0435\u043c\u043e\u043d\u043e\u0432",
  "achievement.banisher_100.name": "\u0418\u0437\u0433\u043e\u043d\u044f\u044e\u0449\u0438\u0439",
  "achievement.banisher_100.desc": "\u0418\u0437\u0433\u043e\u043d\u0438 100 \u0434\u0435\u043c\u043e\u043d\u043e\u0432",
  "achievement.battles_10.name": "\u0412\u0435\u0442\u0435\u0440\u0430\u043d",
  "achievement.battles_10.desc": "\u041d\u0430\u0447\u043d\u0438 10 \u0431\u043e\u0451\u0432",
  "achievement.battles_50.name": "\u0427\u0435\u043c\u043f\u0438\u043e\u043d",
  "achievement.battles_50.desc": "\u041d\u0430\u0447\u043d\u0438 50 \u0431\u043e\u0451\u0432",
  "achievement.played_1h.name": "\u041f\u043e\u0441\u0432\u044f\u0449\u0451\u043d\u043d\u044b\u0439",
  "achievement.played_1h.desc": "\u0418\u0433\u0440\u0430\u0439 \u0441\u0443\u043c\u043c\u0430\u0440\u043d\u043e 1 \u0447\u0430\u0441",
  "achievement.fields_5.name": "\u0418\u0441\u0441\u043b\u0435\u0434\u043e\u0432\u0430\u0442\u0435\u043b\u044c",
  "achievement.fields_5.desc": "\u041e\u0441\u0432\u044f\u0442\u0438 5 \u0440\u0430\u0437\u043d\u044b\u0445 \u0437\u0435\u043c\u0435\u043b\u044c",
  "achievement.fields_20.name": "\u0417\u0430\u0432\u043e\u0435\u0432\u0430\u0442\u0435\u043b\u044c",
  "achievement.fields_20.desc": "\u041e\u0441\u0432\u044f\u0442\u0438 20 \u0440\u0430\u0437\u043d\u044b\u0445 \u0437\u0435\u043c\u0435\u043b\u044c",
  "achievement.priest_level_5.name": "\u0410\u0434\u0435\u043f\u0442",
  "achievement.priest_level_5.desc": "\u0414\u043e\u0441\u0442\u0438\u0433\u043d\u0438 5 \u0443\u0440\u043e\u0432\u043d\u044f \u0436\u0440\u0435\u0446\u0430",
  "achievement.priest_level_10.name": "\u041c\u0430\u0441\u0442\u0435\u0440",
  "achievement.priest_level_10.desc": "\u0414\u043e\u0441\u0442\u0438\u0433\u043d\u0438 10 \u0443\u0440\u043e\u0432\u043d\u044f \u0436\u0440\u0435\u0446\u0430",
  "achievement.early_wave_light_100.name": "\u0421\u043c\u0435\u043b\u044b\u0439 \u0441\u0440\u043e\u043a I",
  "achievement.early_wave_light_100.desc": "\u0421\u043e\u0431\u0440\u0430\u0442\u044c 100 \u0421\u0432\u0435\u0442\u0430 \u0437\u0430 \u0440\u0430\u043d\u043d\u0438\u0435 \u0432\u043e\u043b\u043d\u044b (\u0432\u0441\u0435\u0433\u043e)",
  "achievement.early_wave_light_2000.name": "\u0421\u043c\u0435\u043b\u044b\u0439 \u0441\u0440\u043e\u043a II",
  "achievement.early_wave_light_2000.desc": "\u0421\u043e\u0431\u0440\u0430\u0442\u044c 2000 \u0421\u0432\u0435\u0442\u0430 \u0437\u0430 \u0440\u0430\u043d\u043d\u0438\u0435 \u0432\u043e\u043b\u043d\u044b (\u0432\u0441\u0435\u0433\u043e)",
  "achievement.early_wave_light_50000.name": "\u0421\u043c\u0435\u043b\u044b\u0439 \u0441\u0440\u043e\u043a III",
  "achievement.early_wave_light_50000.desc": "\u0421\u043e\u0431\u0440\u0430\u0442\u044c 50000 \u0421\u0432\u0435\u0442\u0430 \u0437\u0430 \u0440\u0430\u043d\u043d\u0438\u0435 \u0432\u043e\u043b\u043d\u044b (\u0432\u0441\u0435\u0433\u043e)",
  "achievement.early_wave_light_100000.name": "\u0421\u043c\u0435\u043b\u044b\u0439 \u0441\u0440\u043e\u043a IV",
  "achievement.early_wave_light_100000.desc": "\u0421\u043e\u0431\u0440\u0430\u0442\u044c 100000 \u0421\u0432\u0435\u0442\u0430 \u0437\u0430 \u0440\u0430\u043d\u043d\u0438\u0435 \u0432\u043e\u043b\u043d\u044b (\u0432\u0441\u0435\u0433\u043e)",
  "achievement.early_wave_calls_500.name": "\u041d\u0435\u0443\u0441\u0442\u0430\u043d\u043d\u044b\u0439 \u0432\u0435\u0441\u0442\u043d\u0438\u043a",
  "achievement.early_wave_calls_500.desc": "500 \u0440\u0430\u043d\u043d\u0438\u0445 \u0432\u044b\u0437\u043e\u0432\u043e\u0432 \u0441\u043f\u0430\u0432\u043d\u0430 (\u0432\u0441\u0435\u0433\u043e)",

  // Toast notifications — build errors
  "hud.fieldLocked": "Поле ещё не разблокировано",
  "hud.fieldLockedHint": "Пройди соседнее поле",

  // Toast notifications
  "toast.levelUp": "\u0416\u0440\u0435\u0446 \u0423\u0440. {{level}}!",
  "toast.levelUpSubtitle": "\u0422\u0432\u043e\u044f \u0434\u0443\u0445\u043e\u0432\u043d\u0430\u044f \u0441\u0438\u043b\u0430 \u0440\u0430\u0441\u0442\u0451\u0442",
  "toast.giftsUnlocked": "\u041e\u0442\u043a\u0440\u044b\u0442\u044b \u043d\u043e\u0432\u044b\u0435 \u0434\u0430\u0440\u044b",
  "toast.giftUnlockedSubtitle": "{{name}} \u00b7 \u0431\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u044c: {{points}}",
  "toast.giftsUnlockedSubtitle": "\u041d\u043e\u0432\u044b\u0445 \u0434\u0430\u0440\u043e\u0432: {{count}} \u00b7 \u0431\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u044c: {{points}}",
  "toast.giftsAvailable": "\u0415\u0441\u0442\u044c \u0431\u043b\u0430\u0433\u043e\u0434\u0430\u0442\u044c",
  "toast.giftsAvailableSubtitle": "\u0414\u0430\u0440\u044b: {{points}} \u043e\u0447\u043a.",
  "toast.earlyWaveManaTitle": "+{{n}} \u0421\u0432\u0435\u0442\u0430",
  "toast.earlyWaveManaSubtitle": "\u0420\u0430\u043d\u043d\u0438\u0439 \u0432\u044b\u0437\u043e\u0432 \u0432\u043e\u043b\u043d\u044b",

  // Locale toggle — label shows where you'll switch TO (on RU, show EN)
  "locale.toggle": "\u0420\u0423",

  // Mobile portrait overlay
  "mobile.rotateDevice": "Поверните устройство горизонтально",
};
